var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    fill: "#F77E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.307 27.3078V46.6922C48.307 47.8349 47.8538 48.9299 47.045 49.7376C46.2373 50.5464 45.1419 51 43.9993 51H20.3078C19.1651 51 18.0697 50.5464 17.262 49.7376C16.4533 48.9299 16 47.8349 16 46.6922V27.3078C16 26.1651 16.4532 25.0701 17.262 24.2624C18.0697 23.4536 19.1651 23 20.3078 23H43.9993C45.1419 23 46.2373 23.4536 47.045 24.2624C47.8538 25.0701 48.307 26.1651 48.307 27.3078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2296 28.1016V45.8983C61.2296 46.2957 61.0111 46.6606 60.661 46.8481C60.3109 47.0356 59.8858 47.015 59.5552 46.7944L50.4604 40.7313V33.2681L59.5552 27.205C59.8858 26.9843 60.3109 26.9638 60.661 27.1513C61.0111 27.3388 61.2296 27.7037 61.2296 28.101V28.1016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.9fd24203450dd142d2eb2782118359bb.svg";
export { ForwardRef as ReactComponent };